import { memo } from 'react'
import { useI18n } from '../i18n/I18nContext'

interface LoadingSpinnerProps {
  size?: 'small' | 'medium' | 'large'
  message?: string
}

export const LoadingSpinner = memo(function LoadingSpinner({
  size = 'medium',
  message,
}: LoadingSpinnerProps) {
  const { t } = useI18n()
  const text = message ?? t('loading.default')
  const sizeClasses = {
    small: 'spinner-small',
    medium: 'spinner-medium',
    large: 'spinner-large'
  }

  return (
    <div className="loading-spinner-container">
      <div className={`spinner ${sizeClasses[size]}`}></div>
      {text && <p className="loading-message">{text}</p>}
    </div>
  )
})
